import React from 'react';
import { Link } from 'react-router-dom';
import UserProfile from './UserProfile';

const MobileMenu = ({
  isSidebarOpen,
  setIsSidebarOpen,
  navigation,
  isProductsExpanded,
  isOrdersExpanded,
  isStockExpanded,
  isCaisseExpanded,
  isAchatsExpanded,
  handleProductsClick,
  handleOrdersClick,
  handleStockClick,
  handleCaisseClick,
  handleAchatsClick,
  isCurrentPath,
  isSubPathActive,
  user,
  getUserAvatar,
  handleLogout,
  ChevronDownIcon
}) => {
  if (!isSidebarOpen) return null;

  return (
    <div className="fixed inset-0 flex z-40 lg:hidden">
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-gray-600 bg-opacity-75 transition-opacity" 
        onClick={() => setIsSidebarOpen(false)}
      ></div>

      {/* Mobile menu panel */}
      <div className="relative flex-1 flex flex-col max-w-xs w-full bg-gradient-to-b from-[#174540] to-[#0d2926] shadow-xl transition-all transform">
        {/* Close button */}
        <div className="flex items-center justify-end p-4 border-b border-[#0a201e]/70">
          <button
            className="flex items-center justify-center h-8 w-8 rounded-full bg-[#0a201e]/80 hover:bg-[#0a201e] text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white transition-colors"
            onClick={() => setIsSidebarOpen(false)}
          >
            <span className="sr-only">Fermer le menu</span>
            <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Logo section */}
        <div className="flex-shrink-0 px-4 pt-2 pb-4">
          <div className="flex items-center justify-start">
            <div className="flex items-center space-x-3">
              <Link to="/" className="bg-gradient-to-br from-white to-white/90 p-1.5 rounded-lg shadow-lg ring-2 ring-emerald-500/30 relative group">
                <div className="absolute inset-0 rounded-lg bg-emerald-500/10 group-hover:bg-emerald-500/20 transition-all duration-300"></div>
                <div className="absolute -inset-0.5 rounded-lg bg-gradient-to-br from-emerald-400/20 to-teal-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-sm"></div>
                <img
                  src="/logo.jpg"
                  alt="Logo du panneau d'administration"
                  className="h-8 w-8 object-contain rounded-md relative z-10"
                />
              </Link>
              <div className="flex flex-col">
                <span className="text-white font-bold text-lg tracking-tight">Admin</span>
                <div className="flex items-center">
                  <span className="text-emerald-400 text-xs font-semibold tracking-wider">DASHBOARD</span>
                  <span className="ml-1.5 h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex-1 h-0 pt-2 pb-4 overflow-y-auto">
          {/* User profile section */}
          <div className="px-3 mb-6">
            <UserProfile
              user={user}
              getUserAvatar={getUserAvatar}
              handleLogout={handleLogout}
            />
          </div>

          {/* Navigation Menu */}
          <nav className="px-3 space-y-1.5">
            <div className="flex items-center justify-between px-3 mb-2">
              <div className="text-xs font-semibold text-emerald-400 uppercase tracking-wider flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1.5" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
                Menu Principal
              </div>
              <div className="h-px flex-1 bg-gradient-to-r from-emerald-500/20 to-transparent ml-2"></div>
            </div>

            {navigation.map((item) => (
              <div key={item.name} className="mb-2.5 relative group">
                {item.hasDropdown ? (
                  <div>
                    <button
                      className={`${isSubPathActive(item.href)
                        ? 'bg-gradient-to-r from-[#174540] to-[#1c5651] text-white shadow-lg ring-1 ring-emerald-600/20'
                        : 'text-gray-100 hover:bg-[#0a201e]/40 hover:text-white'
                        } group flex items-center justify-between w-full px-3 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ease-in-out`}
                      onClick={item.name === 'Produits' ? handleProductsClick :
                        item.name === 'Commandes' ? handleOrdersClick :
                        item.name === 'Stock' ? handleStockClick :
                        item.name === 'Caisse' ? handleCaisseClick :
                        item.name === 'Achats' ? handleAchatsClick : null}
                    >
                      <div className="flex items-center">
                        <span className={`inline-flex items-center justify-center w-6 h-6 ${isSubPathActive(item.href) ? 'text-emerald-300' : 'text-emerald-400 group-hover:text-emerald-300'} transition-colors duration-200`}>
                          <item.icon />
                        </span>
                        <span className="ml-3">{item.name}</span>
                      </div>
                      <span className={`text-gray-400 transition-transform duration-300 ease-in-out transform ${(item.name === 'Produits' && isProductsExpanded) ||
                        (item.name === 'Commandes' && isOrdersExpanded) ||
                        (item.name === 'Stock' && isStockExpanded) ||
                        (item.name === 'Caisse' && isCaisseExpanded) ||
                        (item.name === 'Achats' && isAchatsExpanded) ? 'rotate-180' : ''
                        }`}>
                        <ChevronDownIcon />
                      </span>
                    </button>

                    <div
                      className={`mt-1 space-y-1 transition-all duration-300 ease-in-out overflow-hidden ${(item.name === 'Produits' && isProductsExpanded) ||
                        (item.name === 'Commandes' && isOrdersExpanded) ||
                        (item.name === 'Stock' && isStockExpanded) ||
                        (item.name === 'Caisse' && isCaisseExpanded) ||
                        (item.name === 'Achats' && isAchatsExpanded)
                        ? 'max-h-80 opacity-100'
                        : 'max-h-0 opacity-0 pointer-events-none'
                        }`}
                      style={{ transitionProperty: 'max-height, opacity, margin' }}
                    >
                      {item.subItems.map((subItem) => (
                        <Link
                          key={subItem.name}
                          to={subItem.href}
                          className={`${isCurrentPath(subItem.href)
                            ? 'bg-[#1c5651]/30 text-white border-l-2 border-emerald-400'
                            : 'text-gray-300 hover:bg-[#1c5651]/20 hover:text-white border-l-2 border-transparent'
                            } group flex items-center pl-10 pr-3 py-2.5 text-sm font-medium rounded-r-lg transition-all duration-200 ease-in-out relative`}
                          onClick={() => setIsSidebarOpen(false)}
                        >
                          {isCurrentPath(subItem.href) && (
                            <span className="absolute inset-y-0 left-0 w-0.5 bg-gradient-to-b from-emerald-400 via-emerald-300 to-emerald-400"></span>
                          )}
                          <span className="w-5 h-5 inline-flex items-center justify-center text-emerald-400/80">
                            {subItem.icon && <subItem.icon />}
                          </span>
                          <span className="ml-3 truncate">{subItem.name}</span>
                        </Link>
                      ))}
                    </div>
                  </div>
                ) : (
                  <Link
                    to={item.href}
                    className={`${isCurrentPath(item.href)
                      ? 'bg-gradient-to-r from-[#174540] to-[#1c5651] text-white shadow-lg ring-1 ring-emerald-600/20'
                      : 'text-gray-100 hover:bg-[#0a201e]/40 hover:text-white'
                      } group flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ease-in-out relative`}
                    onClick={() => setIsSidebarOpen(false)}
                  >
                    {isCurrentPath(item.href) && (
                      <span className="absolute inset-y-1.5 left-0 w-1 bg-emerald-400 rounded-r-full"></span>
                    )}
                    <span className={`inline-flex items-center justify-center w-6 h-6 ${isCurrentPath(item.href) ? 'text-emerald-300' : 'text-emerald-400 group-hover:text-emerald-300'} transition-colors duration-200`}>
                      <item.icon />
                    </span>
                    <span className="ml-3">{item.name}</span>

                    {isCurrentPath(item.href) && (
                      <span className="absolute inset-0 rounded-lg bg-emerald-500/5 blur-sm -z-10"></span>
                    )}
                  </Link>
                )}

                <div className={`absolute right-0 inset-y-0 w-1 bg-emerald-400/60 rounded-l-full scale-y-0 group-hover:scale-y-100 transition-transform ease-out duration-200 origin-center ${isCurrentPath(item.href) || isSubPathActive(item.href) ? 'opacity-0' : 'opacity-100'}`}></div>
              </div>
            ))}
          </nav>
        </div>

        {/* Pro badge at bottom */}
        <div className="flex-shrink-0 p-4 border-t border-[#0a201e]/70">
          <div className="p-3 rounded-xl bg-gradient-to-br from-[#112f2c] to-[#0a201e] shadow-lg ring-1 ring-black/10 flex items-center space-x-3">
            <div className="h-8 w-8 rounded-full bg-gradient-to-br from-emerald-500/20 to-teal-500/20 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-emerald-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-white">Admin Pro</p>
              <p className="text-xs text-gray-400">Votre accès est actif</p>
            </div>
            <button className="h-7 px-2 bg-emerald-700/30 hover:bg-emerald-700/50 text-xs font-medium text-emerald-300 rounded transition-colors duration-200">
              Gérer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;